
import {
    Typography,
    Box,
    Link,
    createTheme,
    ThemeProvider,
} from "@mui/material";
import baseTheme from "../../../themes/baseTheme";
import React, { useState, useEffect } from "react";
import GetfVDateFormate from "../../../utils/Genaricfunctions";

export default function RecentDocumentsGriditem({ status, headers = [], statusRoleMap, ...props }) {
    return (
        <Box className="mt-2" sx={{ width: "100%" }}>

            <Box width={headers.find((h) => h.id === "VendorName")}>
                <a
                    variant="body2"
                    style={{
                        textDecoration: "none",
                        color: "#2A93DB",
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        fontWeight: "500",
                    }}
                    href={"/vendordetails?pqid=" + props?.prequalificationId + "&tab=Questionnaire&sectionid=" + props?.templateSectionID}
                >
                    {props?.vendorName}
                </a>
            </Box>
            <Box width={headers.find((h) => h.id === "documentTypeName")}>
                <Typography variant="body2">{props?.documentTypeName}</Typography>
            </Box>
            <Box width={headers.find((h) => h.id === "vendorStatus")}>
                <Typography variant="body2">{props?.vendorStatus}</Typography>
            </Box>
            
            <Box width={headers.find((h) => h.id === "expirationDate")}>
                <Typography variant="body2"> {props?.expirationDate == "" ? "" : GetfVDateFormate(props?.expirationDate)}</Typography>
            </Box>
            <Box width={headers.find((h) => h.id === "clientName")}>
                <Typography variant="body2">{props?.clientName}</Typography>
            </Box>
            <Box width={headers.find((h) => h.id === "dateUploaded")} >
                <Typography variant="body2"> {GetfVDateFormate(props?.dateUploaded)}</Typography>
            </Box>

        </Box>
    )
}